export default __webpack_public_path__ + "static/media/Tutor.ce68f9ad.png";